module.exports = __webpack_public_path__ + "static/media/blue-pink-donuts.24d863de.jpeg";